module.exports = __webpack_public_path__ + "img/vertical_3_1_8017.8caf9917.png";